import _jsx from '@babel/runtime/helpers/jsx';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import 'react';
import 'prop-types';
import Card, { CardContent } from '@andes/card';
import Thumbnail, { ThumbnailMultiple } from '@andes/thumbnail';
import { Image } from 'frontend-image';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { jsx, Fragment } from 'react/jsx-runtime';
var _Service;
/**
 * Service interface
 */
class Service {}
/**
 * Expose Service
 */
_Service = Service;
_defineProperty(Service, "replaceBlanksWithDash", str => _Service.replaceBlanks(str, '-'));
_defineProperty(Service, "replaceBlanks", (str, value) => str.replace(/ /g, value));
_defineProperty(Service, "capitalizeFirstLetter", str => str[0].toUpperCase() + str.slice(1));
const TrendsEntry = props => {
  const namespace = 'seo-ui-trends-entry';
  const {
    trend,
    deviceType,
    insideCarousel,
    showImage,
    preload,
    supportWebP,
    thumbnailSize,
    animated,
    mounted,
    lazyload
  } = props;
  const MOBILE_TYPE = 'mobile';
  const MOBILE_IMAGES_COUNT = 2;
  const DESKTOP_IMAGES_COUNT = 3;
  const countImagesForDevice = deviceType === MOBILE_TYPE ? MOBILE_IMAGES_COUNT : DESKTOP_IMAGES_COUNT;
  const mapFallBackImageUrls = () => trend.images.map(image => image.url);
  const enrichTrend = () => {
    const images = trend.images.map(image => {
      let url = image.url.replace('http://', 'https://').replace(/-[a-zA-Z].jpg/, '-I.jpg').replace(/ml[a-zA-Z]-s[0-9]-p.mlstatic.com[/]/, 'http2.mlstatic.com/D_Q_NP_');
      if (supportWebP) {
        url = url.replace('.jpg', '.webp');
      }
      return _objectSpread(_objectSpread({}, image), {}, {
        url
      });
    });
    return _objectSpread(_objectSpread({}, trend), {}, {
      images
    });
  };
  const fallBackImageUrls = mapFallBackImageUrls();
  const enrichedTrend = enrichTrend();
  const getImageKeyValue = image => Service.replaceBlanksWithDash(image.description);
  const getSlicedImages = () => enrichedTrend.images ? enrichedTrend.images.slice(0, countImagesForDevice) : [];
  return /*#__PURE__*/_jsx(Card, {
    className: "".concat(namespace, "-container"),
    paddingSize: 0,
    animated: animated
  }, void 0, /*#__PURE__*/_jsx(CardContent, {}, void 0, enrichedTrend.description && /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "-description")
  }, void 0, "".concat(enrichedTrend.description)), /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "-content")
  }, void 0, /*#__PURE__*/_jsx(ThumbnailMultiple, {
    modifier: "circle",
    type: "stacked",
    containerSize: thumbnailSize
  }, void 0, /*#__PURE__*/jsx(Fragment, {
    children: getSlicedImages().map((image, index) => /*#__PURE__*/_jsx(Thumbnail, {
      size: thumbnailSize
    }, getImageKeyValue(image), insideCarousel ? /*#__PURE__*/_jsx(Image, {
      mounted: mounted,
      carousel: true,
      alt: image.description,
      src: image.url,
      srcFallback: fallBackImageUrls[index],
      preload: preload
    }) : /*#__PURE__*/_jsx(Image, {
      preload: preload && showImage,
      lazyload: lazyload,
      alt: image.description,
      src: image.url,
      srcFallback: fallBackImageUrls[index]
    })))
  })), /*#__PURE__*/_jsx("a", {
    href: enrichedTrend.url,
    className: "".concat(namespace, "-link")
  }, void 0, /*#__PURE__*/_jsx("h3", {
    className: "".concat(namespace, "-keyword")
  }, void 0, Service.capitalizeFirstLetter(enrichedTrend.keyword))))));
};
TrendsEntry.defaultProps = {
  preload: undefined,
  insideCarousel: false,
  showImage: true,
  thumbnailSize: '48',
  animated: false,
  mounted: false,
  lazyload: 'off'
};

/**
 * Inject i18n context as props into TrendsEntry.
 */
TrendsEntry.displayName = 'TrendsEntry';
export { TrendsEntry as default };
